import TextWithUpArrow from './text-with-up-arrow';

export default TextWithUpArrow;
